/* eslint-disable camelcase */
import {
  createSelector,
} from 'reselect';

import {
  getResourceMap,
  getResourceMappedList,
} from './resources';
import {
  getProfile,
} from './profile';

import {
  sortByDate,
  alphSortSearchOptions,
} from './utils';

export const getConversations = createSelector(
  [
    getResourceMappedList('conversations'),
    getProfile('id'),
  ],
  (conversations, profileId) => conversations
    .map(item => ({
      ...item,
      recipient: item.recipients?.filter(r => r.user_id !== profileId)[0],
    }))
    .sort(sortByDate('updated_at')),
);

export const getConversationOptions = createSelector(
  getConversations,
  (conversations) => conversations
    .map(option => ({
      label: option.recipient?.full_name,
      value: String(option.id),
      // color: option.color,
      avatar: option.recipient?.avatar,
    })),
);

export const getMessageClientOptions = createSelector(
  [
    getProfile('id'),
    getResourceMappedList('clients'),
    getResourceMappedList('conversations'),
  ],
  (id, clients, conversations) => {
    const cids = conversations.map(c => c.recipients[1].user_id);

    return clients
      .filter(
        client => cids.indexOf(client.id) === -1 && client.id !== id,
      )
      .map(
        option => ({
          label: `${option.user_profile.first_name} ${option.user_profile.last_name}`,
          value: String(option.id),
          // color: option.color,
          avatar: option.user_profile.avatar?.thumb?.url,
        }),
      )
      .sort(alphSortSearchOptions);
  },
);

export const getMessages = (id?: string) => createSelector(
  [
    getResourceMappedList('messages', id),
    getResourceMap('clients'),
  ],
  (messages, clients) => messages
    .map(message => {
      let avatar = {};
      if (clients[message.sender_id]) {
        avatar = clients[message.sender_id].user_profile.avatar;
      }
      return {
        ...message,
        sender_avatar: avatar,
      };
    })
    .sort(sortByDate('created_at', true)),
);
